export const pmpQuestions = [
    // Framework & Integration
    {
        id: 1,
        category: 'Integration',
        difficulty: 'Easy',
        question: 'What is a Project Charter?',
        options: [
            'A document that formally authorizes the existence of a project and provides the PM with authority',
            'A contract with the vendor',
            'A detailed schedule',
            'A type of boat'
        ],
        correct: 0,
        explanation: 'The Project Charter is valid only if signed by the Sponsor; it launches the project.'
    },
    {
        id: 2,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is the primary output of the "Direct and Manage Project Work" process?',
        options: [
            'Deliverables',
            'Project Management Plan',
            'Change Requests',
            'Accepted Deliverables'
        ],
        correct: 0,
        explanation: 'Deliverables (the actual product/service/result) are the main output here.'
    },
    {
        id: 3,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is Integrated Change Control?',
        options: [
            'The process of reviewing all change requests; approving changes and managing changes to deliverables and OPA',
            'A software tool',
            'A weekly meeting',
            'A quality audit'
        ],
        correct: 0,
        explanation: 'Perform Integrated Change Control is critical to prevent scope creep. Only the CCB (Change Control Board) or PM (if authorized) approves significant changes.'
    },

    // Scope
    {
        id: 4,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is a WBS (Work Breakdown Structure)?',
        options: [
            'A hierarchical decomposition of the total scope of work to be carried out by the project team',
            'A list of tasks',
            'A calendar',
            'A budget document'
        ],
        correct: 0,
        explanation: 'The WBS breaks down the project into manageable chunks called Work Packages.'
    },
    {
        id: 5,
        category: 'Scope',
        difficulty: 'Hard',
        question: 'What is Scope Creep?',
        options: [
            'The uncontrolled expansion to product or project scope without adjustments to time, cost, and resources',
            'Adding value to the customer',
            'Detailed planning',
            'A formal change request'
        ],
        correct: 0,
        explanation: 'Scope creep is usually negative; "Gold Plating" is similar but intentional by the team. Both are discouraged.'
    },

    // Agile & Hybrid
    {
        id: 6,
        category: 'Agile',
        difficulty: 'Easy',
        question: 'Who is responsible for the ROI (Return on Investment) in Scrum?',
        options: [
            'The Product Owner',
            'The Scrum Master',
            'The Development Team',
            'The Project Sponsor'
        ],
        correct: 0,
        explanation: 'The Product Owner maximizes the value of the product derived from the work of the team.'
    },
    {
        id: 7,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is the duration of a Sprint in Scrum?',
        options: [
            'Fixed length, usually 1-4 weeks',
            'Variable length depending on work',
            'Always 3 months',
            'Until the work is done'
        ],
        correct: 0,
        explanation: 'Sprints are time-boxed iterations.'
    },
    {
        id: 8,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What happens in a Sprint Retrospective?',
        options: [
            'The team inspects itself and creates a plan for improvements to be enacted during the next Sprint',
            'The team demonstrates the product',
            'The team plans the next sprint work',
            'The team meets the stakeholders'
        ],
        correct: 0,
        explanation: 'Retrospectives focus on process improvement (quality, interaction, tools).'
    },

    // Schedule
    {
        id: 9,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'What is the "Critical Path"?',
        options: [
            'The sequence of activities that represents the longest path through a project, which determines the shortest possible project duration',
            'The most important tasks',
            'The path with the highest risk',
            'The path with the most resources'
        ],
        correct: 0,
        explanation: 'Activities on the Critical Path have Zero Float. Any delay on this path delays the project.'
    },
    {
        id: 10,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'What is "Crashing" the schedule?',
        options: [
            'Adding resources to activities on the critical path to shorten duration (often increases cost)',
            'Doing activities in parallel',
            'Reducing quality',
            'Canceling the project'
        ],
        correct: 0,
        explanation: 'Crashing trades money for time. Fast Tracking (doing things in parallel) trades risk for time.'
    },

    // Cost
    {
        id: 11,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'In EVM, if CPI (Cost Performance Index) is 0.8, what does it mean?',
        options: [
            'We are over budget. For every $1 spent, we are getting $0.80 of value.',
            'We are under budget.',
            'We are ahead of schedule.',
            'The project is perfect.'
        ],
        correct: 0,
        explanation: 'CPI < 1 is bad (Over Budget). CPI > 1 is good (Under Budget).'
    },
    {
        id: 12,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'What does SPI (Schedule Performance Index) > 1.0 indicate?',
        options: [
            'Ahead of Schedule',
            'Behind Schedule',
            'On Schedule',
            'Over Cost'
        ],
        correct: 0,
        explanation: 'SPI > 1 means you have accomplished more work than was planned.'
    },

    // Quality
    {
        id: 13,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is the difference between Quality Assurance (QA) and Quality Control (QC)?',
        options: [
            'QA focuses on the process (prevention); QC focuses on the product (inspection)',
            'QA is testing; QC is auditing',
            'They are the same',
            'QC is done by the project manager'
        ],
        correct: 0,
        explanation: 'Manage Quality (QA) builds confidence that processes will be followed. Control Quality (QC) verifies the output is correct.'
    },
    {
        id: 14,
        category: 'Quality',
        difficulty: 'Hard',
        question: 'What is the "Pareto Principle"?',
        options: [
            '80/20 Rule: 80% of problems come from 20% of causes',
            'Zero defects',
            'Continuous improvement',
            'Six Sigma'
        ],
        correct: 0,
        explanation: 'Pareto Charts (histograms) help prioritize the "vital few" causes of defects.'
    },

    // Resources
    {
        id: 15,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What are the stages of the Tuckman ladder?',
        options: [
            'Forming, Storming, Norming, Performing, Adjourning',
            'Planning, Doing, Checking, Acting',
            'Initiating, Planning, Executing, Closing',
            'Start, Middle, End'
        ],
        correct: 0,
        explanation: 'Teams go through these stages. Storming is where conflict often occurs.'
    },
    {
        id: 16,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'According to Maslow\'s Hierarchy of Needs, what is the highest level?',
        options: [
            'Self-Actualization',
            'Esteem',
            'Social/Belonging',
            'Safety'
        ],
        correct: 0,
        explanation: 'You must satisfy lower needs (Physiological -> Safety -> Social -> Esteem) before reaching Self-Actualization.'
    },

    // Communications
    {
        id: 17,
        category: 'Communications',
        difficulty: 'Medium',
        question: 'In a team of 5 people, how many communication channels are there? Formula: N(N-1)/2',
        options: [
            '10',
            '5',
            '20',
            '25'
        ],
        correct: 0,
        explanation: '5 * (4) / 2 = 10 channels.'
    },
    {
        id: 18,
        category: 'Communications',
        difficulty: 'Easy',
        question: 'What is "Push" communication?',
        options: [
            'Sending information to specific recipients (e.g., emails, memos), ensuring distribution but not understanding',
            'Intranet sites (Pull)',
            'Live meetings (Interactive)',
            'Social media'
        ],
        correct: 0,
        explanation: 'Push pushes it out; Pull requies them to retrieve it; Interactive is real-time.'
    },

    // Risk
    {
        id: 19,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'Which risk response strategy involves moving the impact of a threat to a third party?',
        options: [
            'Transfer',
            'Avoid',
            'Mitigate',
            'Accept'
        ],
        correct: 0,
        explanation: 'Insurance or warranties are classic examples of Risk Transfer.'
    },
    {
        id: 20,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is the goal of "Mitigate" strategy?',
        options: [
            'To reduce the probability and/or impact of a threat',
            'To eliminate the threat entirely',
            'To verify the threat',
            'To ignore the threat'
        ],
        correct: 0,
        explanation: 'Mitigation lowers the EV (Expected Monetary Value) of the risk.'
    },
    {
        id: 21,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is a "Secondary Risk"?',
        options: [
            'A risk that arises as a direct result of implementing a risk response',
            'A small risk',
            'A residual risk',
            'An opportunity'
        ],
        correct: 0,
        explanation: 'Example: You install a fast server to mitigate performance risk, but now you have a risk of server overheating (Secondary Risk).'
    },

    // Procurement
    {
        id: 22,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'Which contract type has the highest cost risk for the buyer?',
        options: [
            'Cost Plus Percentage of Cost (CPPC)',
            'Firm Fixed Price (FFP)',
            'Time and Materials (T&M)',
            'Fixed Price Incentive Fee'
        ],
        correct: 0,
        explanation: 'In Cost Plus, the buyer pays all costs. FFP has the highest risk for the Seller.'
    },
    {
        id: 23,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What does a "Time and Materials" contract resemble?',
        options: [
            'A hybrid of Fixed Price and Cost Reimbursable',
            'A fixed price only',
            'A cost plus only',
            'A handshake'
        ],
        correct: 0,
        explanation: 'T&M is used when scope is unclear (like hiring consultants).'
    },

    // Stakeholders
    {
        id: 24,
        category: 'Stakeholders',
        difficulty: 'Hard',
        question: 'How do you manage a stakeholder with High Power and High Interest?',
        options: [
            'Manage Closely',
            'Keep Informed',
            'Monitor',
            'Keep Satisfied'
        ],
        correct: 0,
        explanation: 'These are your key players. Low Power/High Interest = Keep Informed. High Power/Low Interest = Keep Satisfied.'
    },
    {
        id: 25,
        category: 'Stakeholders',
        difficulty: 'Easy',
        question: 'Who is a Stakeholder?',
        options: [
            'Anyone who can affect or is affected by the project',
            'Only the customer',
            'Only the sponsor',
            'Only the team'
        ],
        correct: 0,
        explanation: 'Stakeholders include positive and negative influencers.'
    },

    // Ethics & General
    {
        id: 26,
        category: 'Ethics',
        difficulty: 'Medium',
        question: 'You discover a major error in your cost estimate just before a milestone. What do you do?',
        options: [
            'Evaluate the impact and communicate it to stakeholders honestly',
            'Hide it until you can fix it',
            'Blame the estimator',
            'Ignore it'
        ],
        correct: 0,
        explanation: 'PMI Code of Ethics mandates responsibility and honesty.'
    },
    {
        id: 27,
        category: 'Integration',
        difficulty: 'Hard',
        question: 'What is the "Project Management Plan"?',
        options: [
            'It consolidates all subsidiary management plans and baselines',
            'It is the schedule',
            'It is the budget',
            'It is the team list'
        ],
        correct: 0,
        explanation: 'It is the master plan that describes how the project will be executed, monitored, and controlled.'
    },
    {
        id: 28,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is a "Kanban Board"?',
        options: [
            'A visualization tool to optimize the flow of work and limit WIP (Work In Progress)',
            'A Gantt chart',
            'A risk register',
            'A status report'
        ],
        correct: 0,
        explanation: 'Kanban focuses on flow and pull systems.'
    },
    {
        id: 29,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Lessons Learned"?',
        options: [
            'Knowledge gained during a project which shows how project events were addressed or should be addressed in the future',
            'A training course',
            'A mistake',
            'A meeting'
        ],
        correct: 0,
        explanation: 'Lessons Learned Register is updated throughout the project, not just at the end.'
    },
    {
        id: 30,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Float" (Slack)?',
        options: [
            'The amount of time an activity can be delayed without delaying the early start of any successor or the project finish date',
            'Extra time in the schedule',
            'A reserve budget',
            'Lazy time'
        ],
        correct: 0,
        explanation: 'Critical path activities usually have zero float.'
    },

    {
        id: 31,
        category: 'Scope',
        difficulty: 'Easy',
        question: 'What is a "Product Owner" responsible for in Scrum?',
        options: [
            'Prioritizing the backlog and maximizing product value',
            'Facilitating meetings',
            'Writing code',
            'Managing the budget'
        ],
        correct: 0,
        explanation: 'The PO owns the "What", the Team owns the "How".'
    },

    // Situational Questions (PMBOK/Agile Best Practices)
    {
        id: 32,
        category: 'Situational',
        difficulty: 'Hard',
        question: 'A key stakeholder refuses to approve the project charter because they disagree with the scope. What should the PM do first?',
        options: [
            'Meet with the stakeholder to understand their concerns and try to resolve the conflict',
            'Ignore the stakeholder and proceed',
            'Escalate to the sponsor immediately',
            'Change the scope without approval'
        ],
        correct: 0,
        explanation: 'First, seek to understand. Communication and stakeholder engagement are the first steps before escalation.'
    },
    {
        id: 33,
        category: 'Situational',
        difficulty: 'Hard',
        question: 'During a Sprint, the client asks to add a "small" feature. What should the Scrum Master/Team do?',
        options: [
            'Ask the Product Owner to add it to the Product Backlog for future prioritization',
            'Add it to the current Sprint immediately',
            'Tell the client "No"',
            'Do it secretly'
        ],
        correct: 0,
        explanation: 'Scope is protected during a Sprint. Changes go to the PO and the Backlog, not the current Sprint (unless critical and traded).'
    },
    {
        id: 34,
        category: 'Situational',
        difficulty: 'Hard',
        question: 'Your project is CPI 0.8 and SPI 1.2. What is the status?',
        options: [
            'Over budget and Ahead of schedule',
            'Under budget and Behind schedule',
            'Over budget and Behind schedule',
            'Under budget and Ahead of schedule'
        ],
        correct: 0,
        explanation: 'CPI < 1 = Over Budget. SPI > 1 = Ahead of Schedule. You are spending fast to move fast.'
    },
    {
        id: 35,
        category: 'Situational',
        difficulty: 'Medium',
        question: 'Two team members are arguing about a technical solution. The argument is getting heated. What is the best conflict resolution technique?',
        options: [
            'Collaborate/Problem Solve (reach a consensus)',
            'Smooth/Accommodate (play down differences)',
            'Force/Direct (PM decides)',
            'Withdraw/Avoid'
        ],
        correct: 0,
        explanation: 'Collaboration is the best long-term solution. Withdrawal is worst. Forcing is a temporary fix.'
    },

    // Agile Ceremonies & Artifacts
    {
        id: 36,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is the "Definition of Done" (DoD)?',
        options: [
            'A shared understanding of criteria that a product increment must meet to be considered release-ready',
            'When the code is written',
            'When the tester says ok',
            'When the deadline passes'
        ],
        correct: 0,
        explanation: 'DoD ensures quality and transparency. If it\'s not Done, it\'s not released.'
    },
    {
        id: 37,
        category: 'Agile',
        difficulty: 'Easy',
        question: 'What is "Velocity"?',
        options: [
            'The amount of work (story points) a team completes in a Sprint',
            'The speed of the server',
            'The budget burn rate',
            'The risk score'
        ],
        correct: 0,
        explanation: 'Velocity is an empirical metric used for forecasting future sprints.'
    },
    {
        id: 38,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'Who facilitates the Daily Scrum?',
        options: [
            'The Development Team (Scrum Master ensures it happens)',
            'The Product Owner',
            'The Project Manager',
            'The Sponsor'
        ],
        correct: 0,
        explanation: 'The meeting is FOR the Developers. The SM ensures the process is followed but doesn\'t need to "run" it.'
    },

    // Risk & Procurement Scenarios
    {
        id: 39,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'A risk has occurred that was NOT in the Risk Register. What should you do first?',
        options: [
            'Add it to the Issue Log and create a workaround',
            'Update the Risk Register',
            'Halt the project',
            'Blame the team'
        ],
        correct: 0,
        explanation: 'If it has happened, it is an Issue. You deal with the issue (workaround/fix), then analyze why it wasn\'t identified (Risk Register update).'
    },
    {
        id: 40,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'You want to buy a standard commodity product. Which contract type is best?',
        options: [
            'Fixed Price',
            'Cost Plus',
            'Time and Materials',
            'CPIF'
        ],
        correct: 0,
        explanation: 'For well-defined scope or off-the-shelf items, Fixed Price is simplest and lowest risk for the buyer.'
    },
    {
        id: 41,
        category: 'Procurement',
        difficulty: 'Hard',
        question: 'What is "Make-or-Buy Analysis"?',
        options: [
            'Deciding whether to produce a deliverable internally or purchase it from an external source',
            'Analyzing budget',
            'Analyzing schedule',
            'Analyzing risks'
        ],
        correct: 0,
        explanation: 'It considers direct vs indirect costs, capacity, and strategic importance.'
    },

    // Quality & Process
    {
        id: 42,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is a "Control Chart"?',
        options: [
            'A graph used to study how a process changes over time, determining if it is "in control" (stable)',
            'A project schedule',
            'A organizational chart',
            'A budget chart'
        ],
        correct: 0,
        explanation: 'Control Limits (UCL/LCL) are typically +/- 3 Sigma. Points outside are "Out of Control".'
    },
    {
        id: 43,
        category: 'Process',
        difficulty: 'Hard',
        question: 'What is "Progressive Elaboration"?',
        options: [
            'Iteratively improving the level of detail in a plan as more information becomes available',
            'Making things up as you go',
            'Delaying planning',
            'Scope creep'
        ],
        correct: 0,
        explanation: 'You cannot plan the whole project in detail on Day 1. Plans become more accurate over time.'
    },

    // Stakeholder & Communication
    {
        id: 44,
        category: 'Stakeholders',
        difficulty: 'Medium',
        question: 'A stakeholder claims they haven\'t received status updates. What is the first document to check?',
        options: [
            'Communications Management Plan',
            'Stakeholder Register',
            'Risk Register',
            'Issue Log'
        ],
        correct: 0,
        explanation: 'Check the plan: *Should* they be receiving updates? How? When? If the plan says yes, then you have a execution failure.'
    },
    {
        id: 45,
        category: 'Communication',
        difficulty: 'Easy',
        question: 'What is the biggest barrier to effective communication?',
        options: [
            'Noise (cultural, physical, linguistic)',
            'Distance',
            'Technology',
            'Budget'
        ],
        correct: 0,
        explanation: 'Noise interferes with the transmission and understanding of the message.'
    },

    // Closing
    {
        id: 46,
        category: 'Closing',
        difficulty: 'Medium',
        question: 'The project is complete and deliverables accepted. What is the LAST thing to do?',
        options: [
            'Release resources',
            'Archive project documents',
            'Celebrate',
            'Pay the bills'
        ],
        correct: 0,
        explanation: 'Resources are released only after administrative closure (archiving, lessons learned) is substantially complete.'
    },
    {
        id: 47,
        category: 'Closing',
        difficulty: 'Hard',
        question: 'If a project is terminated early (cancelled), what happens?',
        options: [
            'You must still perform the Close Project or Phase process (document why, archive work done)',
            'Everyone goes home immediately',
            'Delete all data',
            'Refund all money'
        ],
        correct: 0,
        explanation: 'Closure is required for success, failure, or cancellation to preserve organizational assets.'
    },

    // Hybrid / Other
    {
        id: 48,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is the "Kick-off Meeting"?',
        options: [
            'A meeting to align the team and stakeholders, establish expectations, and officially start execution',
            'The first day of work',
            'A party',
            'A networking event'
        ],
        correct: 0,
        explanation: 'It builds commitment and consensus.'
    },
    {
        id: 49,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Resource Leveling"?',
        options: [
            'Adjusting start/end dates to address resource limits (often extends critical path)',
            'Smoothing resources (keeps dates fixed)',
            'Firing people',
            'Hiring people'
        ],
        correct: 0,
        explanation: 'Leveling = Constraints (dates move). Smoothing = optimization (dates stay, float used).'
    },
    {
        id: 50,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is a "Spike" in Agile?',
        options: [
            'A time-boxed research or experiment to reduce risk or understand a requirement',
            'A sudden bug',
            'A difficult user story',
            'A celebration'
        ],
        correct: 0,
        explanation: 'Spikes are used when the team doesn\'t know enough to estimate a story.'
    },
    {
        id: 51,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is the "100% Rule" in WBS?',
        options: [
            'The WBS must include 100% of the work defined by the scope and capture all deliverables (internal, external, interim)',
            'Everyone must work 100%',
            'Budget must be 100% spent',
            '100% quality is required'
        ],
        correct: 0,
        explanation: 'If it\'s not in the WBS, it\'s not in the project.'
    },

    // Cost Management - Deep Dive
    {
        id: 52,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'Your project has an EV of 100, AC of 120, and PV of 100. What is the Cost Variance (CV)?',
        options: [
            '-20',
            '20',
            '0',
            '1.2'
        ],
        correct: 0,
        explanation: 'CV = EV - AC. 100 - 120 = -20. You are over budget.'
    },
    {
        id: 53,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'What does a TCPI (To-Complete Performance Index) of 1.2 mean?',
        options: [
            'Each remaining dollar in the budget must earn $1.20 of value to finish on budget (Harder to achieve)',
            'Each remaining dollar must earn $1.00',
            'The project is under budget',
            'You can relax'
        ],
        correct: 0,
        explanation: 'TCPI > 1 is bad/hard. It means you must perform more efficiently than planned to recover.'
    },
    {
        id: 54,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Management Reserve"?',
        options: [
            'Budget withheld for "unknown unknowns" (unforeseen work) within scope',
            'Budget for "known unknowns" (risks)',
            'Budget for training',
            'Profit margin'
        ],
        correct: 0,
        explanation: 'It is part of the Project Budget but NOT part of the Cost Baseline. PM needs approval to access it.'
    },
    {
        id: 55,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Contingency Reserve"?',
        options: [
            'Budget within the Cost Baseline allocated for identified risks ("known unknowns")',
            'Budget for scope creep',
            'Budget for unknown unknowns',
            'Extra cash'
        ],
        correct: 0,
        explanation: 'PM has authority to use Contingency Reserve for identified risks that materialize.'
    },
    {
        id: 56,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'Formula for Estimate at Completion (EAC) if current variances are expected to continue?',
        options: [
            'EAC = BAC / CPI',
            'EAC = BAC - EV',
            'EAC = AC + (BAC - EV)',
            'EAC = AC + BottomUpETC'
        ],
        correct: 0,
        explanation: 'If the current poor performance continues, you project the final cost by dividing the total budget by the current CPI.'
    },
    {
        id: 57,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'What is "Value Engineering"?',
        options: [
            'An approach to optimize project life cycle costs, save time, increase profits, or improve quality without reducing scope',
            'Buying cheaper materials',
            'Cutting scope',
            'Writing better code'
        ],
        correct: 0,
        explanation: 'It focuses on finding the lowest lifecycle cost to achieve the required function.'
    },
    {
        id: 58,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is the "Cost Performance Index" (CPI)?',
        options: [
            'A measure of cost efficiency: EV / AC',
            'EV / PV',
            'AC / EV',
            'PV - AC'
        ],
        correct: 0,
        explanation: 'The most critical EVM metric. 0.8 means you get 80 cents of value for every dollar spent.'
    },
    {
        id: 59,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Sunk Cost"?',
        options: [
            'Money already spent that cannot be recovered',
            'Money for the boat',
            'Future money',
            'Estimated cost'
        ],
        correct: 0,
        explanation: 'Sunk costs should NOT be considered when deciding whether to continue a project.'
    },
    {
        id: 60,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'Your VAC (Variance at Completion) is negative. What does this mean?',
        options: [
            'You are forecasted to finish Over Budget',
            'You are forecasted to finish Under Budget',
            'You are on budget',
            'You have extra money'
        ],
        correct: 0,
        explanation: 'VAC = BAC - EAC. If EAC (Forecast) is higher than BAC (Budget), VAC is negative.'
    },
    {
        id: 61,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'What is "Three-Point Estimating" (Beta / PERT)?',
        options: [
            '(Optimistic + 4*MostLikely + Pessimistic) / 6',
            '(O + M + P) / 3',
            'Average of guesses',
            'Best Case + Worst Case'
        ],
        correct: 0,
        explanation: 'Weighted average gives more weight to the Most Likely estimate, offering better accuracy than simple average.'
    },
    {
        id: 62,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Parametric Estimating"?',
        options: [
            'Using a statistical relationship between historical data and other variables (e.g., eq. ft * cost per sq. ft)',
            'Guessing',
            'Top-down estimating',
            'Bottom-up estimating'
        ],
        correct: 0,
        explanation: 'Highly accurate if the underlying data and model are solid.'
    },
    {
        id: 63,
        category: 'Cost',
        difficulty: 'Easy',
        question: 'What is the "Cost Baseline"?',
        options: [
            'The approved version of the time-phased project budget, excluding any management reserves',
            'The total budget including management reserves',
            'The amount spent so far',
            'The initial guess'
        ],
        correct: 0,
        explanation: 'Performance is measured against the Baseline. It forms the "S-Curve".'
    },
    {
        id: 64,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Direct Cost"?',
        options: [
            'Costs that are directly attributable to the project work (e.g., labor, materials, travel)',
            'Overhead costs',
            'Utility bills for the HQ',
            'Management salaries'
        ],
        correct: 0,
        explanation: 'Indirect costs (overhead) are usually allocated.'
    },
    {
        id: 65,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'If SPI is 0.9 and CPI is 0.9, what is likely happening?',
        options: [
            'The project is late and over budget',
            'The project is early and under budget',
            'The project is late but saving money',
            'The project is on track'
        ],
        correct: 0,
        explanation: 'Both indexes are < 1, indicating poor performance in schedule and cost.'
    },
    {
        id: 66,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Cost Aggregation"?',
        options: [
            'Summing the lower-level cost estimates associated with the various work packages for a given level within the WBS',
            'Adding up receipts',
            'A math error',
            'Asking for more money'
        ],
        correct: 0,
        explanation: 'Estimates start at activity level, roll up to Work Packages, then Control Accounts, then Project Cost Baseline.'
    },
    {
        id: 67,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'Which EAC formula is used when the original estimate is fundamentally flawed?',
        options: [
            'EAC = AC + BottomUpETC',
            'EAC = BAC / CPI',
            'EAC = BAC - EV',
            'EAC = AC + BAC'
        ],
        correct: 0,
        explanation: 'If the original plan (BAC) is no longer valid, you must re-estimate the remaining work (ETC) from the bottom up.'
    },
    {
        id: 68,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What impact does "Scope Creep" typically have on Cost?',
        options: [
            'Typically increases cost due to unauthorized work',
            'Reduces cost',
            'No impact',
            'Increases quality'
        ],
        correct: 0,
        explanation: 'Uncontrolled changes consume budget without authorized funding.'
    },
    {
        id: 69,
        category: 'Cost',
        difficulty: 'Medium',
        question: 'What is "Life Cycle Costing"?',
        options: [
            'Considering the cost of operations and maintenance (O&M) and disposal, not just project development cost',
            'Cost of the software license',
            'Cost of the team',
            'Cost of a sprint'
        ],
        correct: 0,
        explanation: 'Decisions made during the project (e.g., buying cheap hardware) affect the long-term cost of ownership.'
    },
    {
        id: 70,
        category: 'Cost',
        difficulty: 'Easy',
        question: 'Which document contains the "Code of Accounts"?',
        options: [
            'WBS Dictionary (or WBS)',
            'Risk Register',
            'Project Charter',
            'Stakeholder Register'
        ],
        correct: 0,
        explanation: 'Unique identifiers are assigned to each WBS component to track costs/resources.'
    },
    {
        id: 71,
        category: 'Cost',
        difficulty: 'Hard',
        question: 'Calculate EV if the project is 50% complete and the total Budget (BAC) is $100,000.',
        options: [
            '$50,000',
            '$100,000',
            '$25,000',
            'Cannot be calculated'
        ],
        correct: 0,
        explanation: 'EV = %Complete * BAC. 0.5 * 100,000 = 50,000.'
    },

    // Schedule Management - Deep Dive
    {
        id: 72,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'Activity A (5 days) -> Activity B (3 days) -> Activity C (4 days). Activity A also goes to Activity D (6 days) -> Activity C. What is the Critical Path?',
        options: [
            'A -> D -> C (15 days)',
            'A -> B -> C (12 days)',
            'A -> B -> D',
            'D -> C'
        ],
        correct: 0,
        explanation: 'Path 1: A+B+C = 5+3+4 = 12. Path 2: A+D+C = 5+6+4 = 15. The longest path is the Critical Path (15 days).'
    },
    {
        id: 73,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Free Float"?',
        options: [
            'The amount of time an activity can be delayed without delaying the early start of its successor',
            'The total float',
            'The project buffer',
            'Time for lunch'
        ],
        correct: 0,
        explanation: 'Total Float puts the project end date at risk. Free Float only affects the next task.'
    },
    {
        id: 74,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is a "Lag"?',
        options: [
            'A waiting time inserted between activities (e.g., waiting for concrete to cure)',
            'A delay due to lazy workers',
            'An acceleration',
            'A type of dependency'
        ],
        correct: 0,
        explanation: 'Lag is a directed delay in a logical relationship (FS + 2 days).'
    },
    {
        id: 75,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is a "Lead"?',
        options: [
            'An acceleration of a successor activity (starting it before the predecessor finishes)',
            'The person in charge',
            'A metal',
            'A delay'
        ],
        correct: 0,
        explanation: 'Lead (negative lag) allows overlap (FS - 2 days). e.g., Start painting before the primer is 100% dry on the whole wall.'
    },
    {
        id: 76,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'Which logic relationship is most common in PDM (Precedence Diagramming Method)?',
        options: [
            'Finish-to-Start (FS)',
            'Start-to-Start (SS)',
            'Finish-to-Finish (FF)',
            'Start-to-Finish (SF)'
        ],
        correct: 0,
        explanation: 'Task B cannot start until Task A finishes. This is the standard sequence.'
    },
    {
        id: 77,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'What is "Resource Smoothing"?',
        options: [
            'Adjusting activities within their float limits to optimize resources without changing the Critical Path',
            'Changing the critical path',
            'Hiring more people',
            'Firing people'
        ],
        correct: 0,
        explanation: 'Smoothing is constrained by time (End date doesn\'t change). Leveling is constrained by resources (End date might change).'
    },
    {
        id: 78,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Rolling Wave Planning"?',
        options: [
            'An iterative planning technique where near-term work is planned in detail, while future work is planned at a higher level',
            'Planning everything at once',
            'Never planning',
            'Planning only the end'
        ],
        correct: 0,
        explanation: 'Prevents "Analysis Paralysis" by acknowledging that information becomes clearer as time passes.'
    },
    {
        id: 79,
        category: 'Schedule',
        difficulty: 'Easy',
        question: 'What is a "Milestone"?',
        options: [
            'A significant point or event in a project, having zero duration',
            'A long task',
            'A rock',
            'A meeting'
        ],
        correct: 0,
        explanation: 'Milestones are markers (Start Phase, Design Approved, etc.).'
    },
    {
        id: 80,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is the "Scheule Baseline"?',
        options: [
            'The approved version of the schedule model that can be changed only through formal change control',
            'The initial draft',
            'The current live schedule',
            'The wishlist'
        ],
        correct: 0,
        explanation: 'Benchmarks performance. Actuals are compared against this.'
    },
    {
        id: 81,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'What is "Student Syndrome"?',
        options: [
            'Procrastinating until the last possible moment ("cramming")',
            'Working hard early',
            'Studying too much',
            'Asking too many questions'
        ],
        correct: 0,
        explanation: 'Resource buffers (Critical Chain) help mitigate this and Parkinson\'s Law.'
    },
    {
        id: 82,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'What states "Work expands to fill the time available for its completion"?',
        options: [
            'Parkinson\'s Law',
            'Murphy\'s Law',
            'Moore\'s Law',
            'The Law of Diminishing Returns'
        ],
        correct: 0,
        explanation: 'If you give someone 5 days for a 2-day task, they will take 5 days.'
    },
    {
        id: 83,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Fast Tracking"?',
        options: [
            'Performing activities in parallel that would normally be done in sequence',
            'Adding resources',
            'Skipping steps',
            'Running fast'
        ],
        correct: 0,
        explanation: 'Increases Risk (rework) to save Time.'
    },
    {
        id: 84,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is the "Monte Carlo Simulation" used for in Schedule Management?',
        options: [
            'Computerized analysis that simulates thousands of possible schedule outcomes to assess risk and probability',
            'Gambling',
            'Simple arithmetic',
            'Drawing charts'
        ],
        correct: 0,
        explanation: 'It helps answer "What is the probability of finishing by date X?"'
    },
    {
        id: 85,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'Start-to-Start (SS) relationship means:',
        options: [
            'Successor cannot start until Predecessor starts',
            'Successor starts when Predecessor finishes',
            'They must start at the exact same time',
            'They are unrelated'
        ],
        correct: 0,
        explanation: 'Example: Pouring concrete (P) and Leveling concrete (S). You can start leveling shortly after you start pouring.'
    },
    {
        id: 86,
        category: 'Schedule',
        difficulty: 'Easy',
        question: 'Who provides inputs for activity duration estimates?',
        options: [
            'The person or group on the project team who is most familiar with the nature of the work',
            'Only the PM',
            'Only the Sponsor',
            'A random guess'
        ],
        correct: 0,
        explanation: 'Estimates should come from those doing the work.'
    },
    {
        id: 87,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Decomposition" in Schedule Management?',
        options: [
            'Breaking down Work Packages into Activities',
            'Breaking WBS into Work Packages',
            'Rotting',
            'Analyzing failure'
        ],
        correct: 0,
        explanation: 'Scope WBS goes down to Work Packages. Schedule goes one step further: Activities.'
    },
    {
        id: 88,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'If Total Float is -5 days, what does it mean?',
        options: [
            'The project is 5 days behind schedule',
            'The project is 5 days ahead',
            'You have 5 days of spare time',
            'Calculation error'
        ],
        correct: 0,
        explanation: 'Negative Float means the calculated early finish is after the imposed deadline.'
    },
    {
        id: 89,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is an "Agile Release Plan"?',
        options: [
            'A high-level timeline based on the product roadmap, showing which user stories are targeted for which sprints/releases',
            'A detailed daily schedule',
            'A list of bugs',
            'A contract'
        ],
        correct: 0,
        explanation: 'It provides a product vision without committing to granular dates for every task.'
    },
    {
        id: 90,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'To "crash" a schedule effectively, which activities should you choose?',
        options: [
            'Critical Path activities with the lowest crash cost per time unit',
            'Any activity on the critical path',
            'Non-critical activities',
            'The easiest activities'
        ],
        correct: 0,
        explanation: 'Maximize value: Get the most time saved for the least money added.'
    },
    {
        id: 91,
        category: 'Schedule',
        difficulty: 'Medium',
        question: 'What is "Reserve Analysis" in Scheduling?',
        options: [
            'Adding contingency buffers (time reserves) to the schedule to account for uncertainty',
            'Checking the bank account',
            'Reserving a meeting room',
            'Analyzing past projects'
        ],
        correct: 0,
        explanation: 'Often called "Padding" (bad) if hidden, but "Reserves" (good) if transparent and calculated.'
    },

    // Risk Management - Deep Dive
    {
        id: 92,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is "Expected Monetary Value" (EMV)?',
        options: [
            'Probability * Impact',
            'Cost + Risk',
            'Impact / Probability',
            'Maximum possible loss'
        ],
        correct: 0,
        explanation: 'EMV calculates the average outcome of uncertain scenarios (e.g., 50% chance of losing $10k = -$5k EMV).'
    },
    {
        id: 93,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is a "Residual Risk"?',
        options: [
            'A risk that remains after risk responses have been implemented',
            'A small risk',
            'A new risk',
            'A deleted risk'
        ],
        correct: 0,
        explanation: 'You mitigate a risk, but some danger remains. That leftover piece is Residual Risk.'
    },
    {
        id: 94,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is "Sensitivity Analysis" (Tornado Diagram)?',
        options: [
            'A technique to determine which individual project risks or other sources of uncertainty have the most potential impact on project outcomes',
            'Checking if the team is sensitive',
            'Weather forecasting',
            'Calculating the mean'
        ],
        correct: 0,
        explanation: 'It correlates variations in project outcomes with variations in elements of the quantitative risk analysis model.'
    },
    {
        id: 95,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'Which strategy is appropriate for a Positive Risk (Opportunity)?',
        options: [
            'Exploit, Share, Enhance, Accept',
            'Avoid, Transfer, Mitigate, Accept',
            'Ignore',
            'Escalate only'
        ],
        correct: 0,
        explanation: 'You want to make opportunities happen (Exploit) or increase their probability/impact (Enhance).'
    },
    {
        id: 96,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is "Risk Appetite"?',
        options: [
            'The degree of uncertainty an organization or individual is willing to accept in anticipation of a reward',
            'Hunger for danger',
            'A risk inventory',
            'The cost of insurance'
        ],
        correct: 0,
        explanation: 'High risk appetite = willing to gamble for high returns. Low risk appetite = conservative.'
    },
    {
        id: 97,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is a "Watch List" in Risk Management?',
        options: [
            'A list of low-priority risks that are monitored for change',
            'A list of people to watch',
            'The top 10 risks',
            'Risks that have occurred'
        ],
        correct: 0,
        explanation: 'Low probability/Low impact risks are often put on a watch list rather than spending resources to mitigate them actively.'
    },
    {
        id: 98,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is the purpose of "Perform Qualitative Risk Analysis"?',
        options: [
            'To prioritize risks by assessing their probability of occurrence and impact',
            'To calculate exact costs',
            'To buy insurance',
            'To identify risks'
        ],
        correct: 0,
        explanation: 'It is a subjective, quick filter to separate the "Critical" few from the "Trivial" many.'
    },
    {
        id: 99,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is a "Risk Prompt List"?',
        options: [
            'A predetermined list of risk categories or questions used to aid in identifying risks',
            'A list of deadlines',
            'A contract',
            'A calendar'
        ],
        correct: 0,
        explanation: 'Examples: PESTLE (Political, Economic, Social, Technological, Legal, Environmental).'
    },
    {
        id: 100,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is "Influence Diagram"?',
        options: [
            'A graphical representation of situations showing causal influences, time ordering of events, and other relationships',
            'A org chart',
            'A stakeholder map',
            'A network diagram'
        ],
        correct: 0,
        explanation: 'It helps visualize how risks influence each other and outcomes.'
    },
    {
        id: 101,
        category: 'Risk',
        difficulty: 'Easy',
        question: 'When should risk identification happen?',
        options: [
            'Throughout the entire project lifecycle',
            'Only at the start',
            'Only at the end',
            'Only when a problem occurs'
        ],
        correct: 0,
        explanation: 'Risk Management is an iterative process. New risks emerge constantly.'
    },
    {
        id: 102,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is "Risk Transference"?',
        options: [
            'Shifting the impact of a threat to a third party, together with ownership of the response',
            'Running away',
            'Fixing the risk',
            'Accepting the risk'
        ],
        correct: 0,
        explanation: 'Buying insurance is the classic example. It does NOT eliminate the risk, just who pays for it.'
    },
    {
        id: 103,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is "Risk Acceptance"?',
        options: [
            'Acknowledging the risk but taking no proactive action (Passive) or establishing a contingency reserve (Active)',
            'Denial',
            'Fighting the risk',
            'Escalating'
        ],
        correct: 0,
        explanation: 'Used when the cost of mitigation exceeds the potential loss, or no feasible response exists.'
    },
    {
        id: 104,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is the difference between "Unknown Unknowns" and "Known Unknowns"?',
        options: [
            'Known Unknowns are identified risks (Contingency Reserve); Unknown Unknowns are unidentified risks (Management Reserve)',
            'They are the same',
            'Unknown Unknowns are cheaper',
            'Known Unknowns are ignored'
        ],
        correct: 0,
        explanation: 'You can plan for what you know you don\'t know. You can\'t plan specifically for what you are totally unaware of.'
    },
    {
        id: 105,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is a "Fallout Plan"?',
        options: [
            'A plan to address the residual effects of a risk that has occurred',
            'A plan for winter',
            'A nuclear safety plan',
            'A shutdown plan'
        ],
        correct: 0,
        explanation: 'Sometimes used interchangeably with Contingency Plan, but often refers to "Plan B if Plan A fails".'
    },
    {
        id: 106,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is "Risk Urgency Assessment"?',
        options: [
            'Reviewing risks to determine which need near-term responses',
            'Panicking',
            'Running fast',
            'Calling 911'
        ],
        correct: 0,
        explanation: 'A risk might have high impact but happen in 2 years. Another might be low impact but happens tomorrow. Timing matters.'
    },
    {
        id: 107,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'Which distribution is best for Monte Carlo analysis when data is scarce?',
        options: [
            'Triangular Distribution (Optimistic, Pessimistic, Most Likely)',
            'Normal Distribution',
            'Uniform Distribution',
            'Beta Distribution'
        ],
        correct: 0,
        explanation: 'Triangular is simple and intuitive when you only have the 3 data points.'
    },
    {
        id: 108,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is the "Risk Register"?',
        options: [
            'A repository in which outputs of risk management processes are recorded',
            'A list of dangerous employees',
            'A safety log',
            'A financial journal'
        ],
        correct: 0,
        explanation: 'It is a living document updated constantly.'
    },
    {
        id: 109,
        category: 'Risk',
        difficulty: 'Easy',
        question: 'What is a "Trigger Condition"?',
        options: [
            'An event or situation that indicates that a risk is about to occur or has occurred',
            'A gun mechanism',
            'A happy event',
            'A project start'
        ],
        correct: 0,
        explanation: 'Also called warning signs or symptoms.'
    },
    {
        id: 110,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is "Escalation" as a risk response?',
        options: [
            'Moving the risk to a higher level of authority because it is outside the scope of the project',
            'Yelling',
            'Fighting',
            'Ignoring'
        ],
        correct: 0,
        explanation: 'If you can\'t fix it and it affects the program/portfolio, you escalate it.'
    },
    {
        id: 111,
        category: 'Risk',
        difficulty: 'Hard',
        question: 'What is the "Probability and Impact Matrix"?',
        options: [
            'A grid for mapping the probability of each risk outcome against its impact on project objectives',
            'A movie',
            'A math formula',
            'A schedule tool'
        ],
        correct: 0,
        explanation: 'It provides a standardizes way to rank risks (e.g., Red/Yellow/Green).'
    },

    // Agile & Hybrid - Deep Dive
    {
        id: 112,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Servant Leadership"?',
        options: [
            'A leadership style that focuses on the growth and well-being of people and the communities to which they belong',
            'Being a servant to the boss',
            'Command and Control',
            'Doing all the work yourself'
        ],
        correct: 0,
        explanation: 'The Agile PM/Scrum Master removes impediments and "serves" the team.'
    },
    {
        id: 113,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What are the 3 pillars of Scrum?',
        options: [
            'Transparency, Inspection, Adaptation',
            'Scope, Time, Cost',
            'Planning, Executing, Closing',
            'Users, Developers, Managers'
        ],
        correct: 0,
        explanation: 'These support the empirical process control theory.'
    },
    {
        id: 114,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Pair Programming"?',
        options: [
            'An XP technique where two programmers work together at one workstation',
            'Working in two different rooms',
            'Working on two computers',
            'A double monitor setup'
        ],
        correct: 0,
        explanation: 'One drives (writes code), the other navigates (reviews/thinks). Improves quality.'
    },
    {
        id: 115,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Refactoring"?',
        options: [
            'Improving the internal structure of code without changing its external behavior',
            'Rewriting the app',
            'Fixing bugs',
            'Adding features'
        ],
        correct: 0,
        explanation: 'Crucial in Agile to keep technical debt low.'
    },
    {
        id: 116,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is "Osmotic Communication"?',
        options: [
            'Information flowing into the background hearing of team members in a shared workspace',
            'Email',
            'Telepathy',
            'Formal memos'
        ],
        correct: 0,
        explanation: 'A key benefit of co-location ("Caves and Common").'
    },
    {
        id: 117,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is a "Burn-down Chart"?',
        options: [
            'A graphical representation of work left to do versus time',
            'A chart of fire',
            'A budget chart',
            'A scope chart'
        ],
        correct: 0,
        explanation: 'If the line is above the ideal trend, the team is behind.'
    },
    {
        id: 118,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Test-Driven Development" (TDD)?',
        options: [
            'Writing a failing test before writing the functional code',
            'Testing after coding',
            'Testing by users',
            'QA testing'
        ],
        correct: 0,
        explanation: 'Red -> Green -> Refactor.'
    },
    {
        id: 119,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is "Little\'s Law"?',
        options: [
            'Cycle Time = Work in Progress (WIP) / Throughput',
            'Work fills time',
            'Small teams are better',
            'Agile is fast'
        ],
        correct: 0,
        explanation: 'To reduce Cycle Time (get faster), you must either reduce WIP or increase Throughput.'
    },
    {
        id: 120,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is the "Crystal" family of methodologies?',
        options: [
            'A family of agile methodologies that focuses on people and their interactions, categorized by colors (Clear, Yellow, Orange) based on team size/criticality',
            'A gemstone',
            'A rigid process',
            'A waterfall method'
        ],
        correct: 0,
        explanation: 'Crystal adjusts the weight of the methodology to fit the project.'
    },
    {
        id: 121,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is a "Persona"?',
        options: [
            'A fictional character created to represent a user type that might use a site, brand, or product',
            'A real user',
            'The view of the boss',
            'A marketing slogan'
        ],
        correct: 0,
        explanation: 'Personas help the team empathize with user needs.'
    },
    {
        id: 122,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Planning Poker"?',
        options: [
            'A consensus-based, gamified technique for estimating, mostly used to estimate effort or relative size of user stories',
            'Gambling with budget',
            'A card game for break time',
            'Deciding who buys lunch'
        ],
        correct: 0,
        explanation: 'Uses Fibonacci sequence (1, 2, 3, 5, 8, 13...). Avoids anchoring bias.'
    },
    {
        id: 123,
        category: 'Agile',
        difficulty: 'Easy',
        question: 'What is a "User Story"?',
        options: [
            'As a <role>, I want <feature>, so that <benefit>',
            'A bug report',
            'A technical spec',
            'A novel'
        ],
        correct: 0,
        explanation: 'The standard format for Agile requirements.'
    },
    {
        id: 124,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Information Radiator"?',
        options: [
            'A large display located in a place where passers-by can see it, showing project info (e.g., Kanban board)',
            'A heater',
            'A radio',
            'An email'
        ],
        correct: 0,
        explanation: 'Promotes transparency and osmotic communication.'
    },
    {
        id: 125,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is "Cumulative Flow Diagram" (CFD)?',
        options: [
            'An area graph that depicts the quantity of work in a given state, showing arrival time, departure time, quantity, and cycle time',
            'A flow chart',
            'A pie chart',
            'A river map'
        ],
        correct: 0,
        explanation: 'Used in Kanban. Widening bands indicate bottlenecks.'
    },
    {
        id: 126,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is the "Last Responsible Moment"?',
        options: [
            'The strategy of delaying decisions as long as possible (to keep options open) without causing damage',
            'Procrastination',
            'Laziness',
            'Indecision'
        ],
        correct: 0,
        explanation: 'Deciding too early limits flexibility. Deciding too late causes failure.'
    },
    {
        id: 127,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is a "Sprint Zero"?',
        options: [
            'A preparation phase to set up dev environment, backlog, and team before the first sprint (controversial)',
            'The first real sprint',
            'A failed sprint',
            'A vacation'
        ],
        correct: 0,
        explanation: 'Some purists say there is no Sprint 0; others find it necessary for Setup.'
    },
    {
        id: 128,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is the "MosCoW" method?',
        options: [
            'Prioritization: Must have, Should have, Could have, Won\'t have',
            'A city in Russia',
            'A type of code',
            'A meeting style'
        ],
        correct: 0,
        explanation: 'Helps stakeholders decide what is critical for the MVP.'
    },
    {
        id: 129,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is "Feature Driven Development" (FDD)?',
        options: [
            'An iterative and incremental software development process organized around making progress on features',
            'Just coding',
            'Waterfall in disguise',
            'Testing only'
        ],
        correct: 0,
        explanation: 'Five processes: Develop Model, Build Feature List, Plan by Feature, Design by Feature, Build by Feature.'
    },
    {
        id: 130,
        category: 'Agile',
        difficulty: 'Easy',
        question: 'How long is the Daily Scrum time-boxed to?',
        options: [
            '15 minutes',
            '1 hour',
            '30 minutes',
            '5 minutes'
        ],
        correct: 0,
        explanation: 'It is a sync, not a problem-solving session.'
    },
    {
        id: 131,
        category: 'Agile',
        difficulty: 'Medium',
        question: 'What is "Technical Debt"?',
        options: [
            'The implied cost of additional rework caused by choosing an easy solution now instead of using a better approach that would take longer',
            'Money owed to vendors',
            'Bad computers',
            'Fees'
        ],
        correct: 0,
        explanation: 'Like financial debt, if not paid down (refactored), the interest (maintenance cost) becomes overwhelming.'
    },
    {
        id: 132,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is the "Shu-Ha-Ri" model?',
        options: [
            'A martial arts concept describing stages of learning: Shu (follow rules), Ha (break rules), Ri (be the rule)',
            'A sushi roll',
            'A software',
            'A Japanese city'
        ],
        correct: 0,
        explanation: 'Agile teams typically start by following Scrum rules rigidly (Shu) before adapting them (Ha/Ri).'
    },

    // Scope Management - Deep Dive
    {
        id: 133,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is the difference between "Validate Scope" and "Control Quality"?',
        options: [
            'Validate Scope is about acceptance by stakeholders (external); Control Quality is about meeting technical requirements (internal correctness)',
            'They are the same',
            'Validate Scope is done by the team',
            'Control Quality is done by the customer'
        ],
        correct: 0,
        explanation: 'QC ensures it works. Validate Scope ensures the customer accepts it. QC usually comes before Validate Scope.'
    },
    {
        id: 134,
        category: 'Scope',
        difficulty: 'Easy',
        question: 'What is the "WBS Dictionary"?',
        options: [
            'A document that provides detailed deliverable, activity, and scheduling information about each component in the WBS',
            'A glossary of terms',
            'A list of acronyms',
            'A language translation tool'
        ],
        correct: 0,
        explanation: 'The WBS provides the visual structure; the Dictionary provides the detailed metadata (who, what, when, cost).'
    },
    {
        id: 135,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is "Product Analysis"?',
        options: [
            'A technique to translate project objectives into tangible deliverables and requirements (e.g., Value Analysis)',
            'Testing the product',
            'Selling the product',
            'Marketing analysis'
        ],
        correct: 0,
        explanation: 'Used heavily in projects with a tangible product outcome to define the "What".'
    },
    {
        id: 136,
        category: 'Scope',
        difficulty: 'Hard',
        question: 'What is an "Affinity Diagram"?',
        options: [
            'A technique that allows large numbers of ideas to be classified into groups for review and analysis',
            'A relationship chart',
            'A family tree',
            'A seating chart'
        ],
        correct: 0,
        explanation: 'Often used after brainstorming to organize chaotic ideas into themes.'
    },
    {
        id: 137,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is a "Context Diagram"?',
        options: [
            'A visual depiction of the product scope showing a business system (process, equipment, computer system) and how people/other systems interact with it',
            'A map of the office',
            'A network diagram',
            'A data model'
        ],
        correct: 0,
        explanation: 'Shows the system boundaries and interfaces with external entities.'
    },
    {
        id: 138,
        category: 'Scope',
        difficulty: 'Medium',
        question: 'What is "Gold Plating"?',
        options: [
            'Intentionally adding extra features or functions to the product which were not included in the scope statement',
            'Using real gold',
            'High quality work',
            'Expensive materials'
        ],
        correct: 0,
        explanation: 'PMI discourages this. It consumes resources and adds risk without approved requirement.'
    },
    {
        id: 139,
        category: 'Scope',
        difficulty: 'Hard',
        question: 'What is "Nominal Group Technique"?',
        options: [
            'A structured brainstorming form that prioritizes ideas/solutions using a voting process',
            'A regular meeting',
            'A focus group',
            'A survey'
        ],
        correct: 0,
        explanation: 'More structured than brainstorming. Everyone writes ideas, then votes. Reduces groupthink.'
    },
    {
        id: 140,
        category: 'Scope',
        difficulty: 'Easy',
        question: 'Changes to the Product Scope are usually driven by:',
        options: [
            'New requirements, regulations, or market shifts',
            'Boredom',
            'Too much budget',
            'The developers'
        ],
        correct: 0,
        explanation: 'Scope changes must be managed formally.'
    },

    // Stakeholder Management - Deep Dive
    {
        id: 141,
        category: 'Stakeholders',
        difficulty: 'Hard',
        question: 'What is the "Salience Model" for stakeholder analysis?',
        options: [
            'Classifying stakeholders based on Power, Urgency, and Legitimacy',
            'Classifying based on money',
            'Classifying based on distance',
            'Classifying based on age'
        ],
        correct: 0,
        explanation: 'Helps identify "Definitive" stakeholders (who have all 3 attributes) vs "Dormant" ones.'
    },
    {
        id: 142,
        category: 'Stakeholders',
        difficulty: 'Medium',
        question: 'What is a "Stakeholder Engagement Assessment Matrix"?',
        options: [
            'A matrix that compares current engagement levels to desired engagement levels (e.g., Unaware -> Supportive)',
            'A list of phone numbers',
            'A budget spreadsheet',
            'A risk chart'
        ],
        correct: 0,
        explanation: 'Critical for planning communication. You want to move key people from "Resistant" or "Neutral" to "Supportive".'
    },
    {
        id: 143,
        category: 'Stakeholders',
        difficulty: 'Medium',
        question: 'What is "Active Listening"?',
        options: [
            'Listening to understand rather than to reply, acknowledging and clarifying the message',
            'Listening to music',
            'Nodding while ignoring',
            'Talking a lot'
        ],
        correct: 0,
        explanation: 'A key soft skill for PMs to manage expectations and conflict.'
    },
    {
        id: 144,
        category: 'Stakeholders',
        difficulty: 'Hard',
        question: 'What is the "Power/Interest Grid"?',
        options: [
            'A 2x2 grid used to group stakeholders based on their level of authority (Power) and level of concern (Interest)',
            'An electrical grid',
            'A political map',
            'A interest rate chart'
        ],
        correct: 0,
        explanation: 'Guides the management strategy (Manage Closely, Keep Informed, Keep Satisfied, Monitor).'
    },
    {
        id: 145,
        category: 'Stakeholders',
        difficulty: 'Easy',
        question: 'Who is the "Sponsor"?',
        options: [
            'The person or group providing resources and support for the project, and is accountable for enabling success',
            'The customer',
            'The PM',
            'The vendor'
        ],
        correct: 0,
        explanation: 'The Sponsor authorizes the project (Charter) and handles escalation.'
    },

    // Quality Management - Deep Dive
    {
        id: 146,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is "Kaizen"?',
        options: [
            'Continuous Improvement (small, incremental changes)',
            'A sudden revolution',
            'A type of defect',
            'A quality audit'
        ],
        correct: 0,
        explanation: 'Philosophy that everyone in the organization should constantly look for ways to improve.'
    },
    {
        id: 147,
        category: 'Quality',
        difficulty: 'Hard',
        question: 'What is "Six Sigma"?',
        options: [
            'A data-driven approach to eliminate defects (aiming for 3.4 defects per million opportunities)',
            'Six managers',
            'A agile method',
            'A networking standard'
        ],
        correct: 0,
        explanation: 'Uses DMAIC (Define, Measure, Analyze, Improve, Control).'
    },
    {
        id: 148,
        category: 'Quality',
        difficulty: 'Hard',
        question: 'What is "Design of Experiments" (DOE)?',
        options: [
            'A statistical method to identify which factors may influence specific variables of a product or process',
            'Designing a lab',
            'Guessing',
            'Trial and error'
        ],
        correct: 0,
        explanation: 'Helps optimize products by testing multiple variables simultaneously.'
    },
    {
        id: 149,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is a "Checksheet"?',
        options: [
            'A structured form (tally sheet) for collecting and analyzing data',
            'A checklist',
            'A bill',
            'A contract'
        ],
        correct: 0,
        explanation: 'Not to be confused with a Checklist. Checksheets tally frequencies (e.g., how many errors of type A?).'
    },
    {
        id: 150,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is "Cost of Quality" (COQ)?',
        options: [
            'Total cost of conformance (prevention/appraisal) + non-conformance (internal/external failure)',
            'Price of the product',
            'Salary of QA',
            'Cost of luxury'
        ],
        correct: 0,
        explanation: 'Prevention is cheaper than correction. External Failure (warranty/lawsuits) is most expensive.'
    },

    // Resources & Team - Deep Dive
    {
        id: 151,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is "Virtual Teams"?',
        options: [
            'Groups of people with a shared goal who fulfill their roles with little or no time spent face-to-face',
            'AI bots',
            'Video game players',
            'Imaginary friends'
        ],
        correct: 0,
        explanation: 'Requires distinct communication planning and trust-building strategies.'
    },
    {
        id: 152,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'What is "Theory X" and "Theory Y"?',
        options: [
            'Theory X assumes people dislike work (need micromanagement); Theory Y assumes people are self-motivated',
            'A math theory',
            'Genetic theory',
            'Management by walking around'
        ],
        correct: 0,
        explanation: 'McGregor\'s theories. Agile aligns with Theory Y.'
    },
    {
        id: 153,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is a "RACI Chart"?',
        options: [
            'Responsible, Accountable, Consult, Inform (Assignment Matrix)',
            'A race track',
            'A calendar',
            'A org chart'
        ],
        correct: 0,
        explanation: 'Clarifies roles. Only ONE person should be Accountable for a task.'
    },
    {
        id: 154,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'What is "Herzberg’s Two-Factor Theory"?',
        options: [
            'Hygiene factors (salary, conditions) prevent dissatisfaction but don\'t motivate; Motivators (achievement, recognition) drive performance',
            'Two managers per team',
            'Carrot and Stick',
            'Supply and Demand'
        ],
        correct: 0,
        explanation: 'You can\'t motivate someone effectively if their hygiene needs (pay, safety) aren\'t met first.'
    },
    {
        id: 155,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is "Pre-assignment"?',
        options: [
            'When project team members are selected in advance (e.g., promised in a proposal or specific expertise required)',
            'Guessing who will work',
            'Hiring early',
            'Assigning homework'
        ],
        correct: 0,
        explanation: 'Occurs before the project formally starts.'
    },

    // Integration & General
    {
        id: 156,
        category: 'Integration',
        difficulty: 'Hard',
        question: 'What is "Configuration Management"?',
        options: [
            'Managing changes to the documentation, hardware, software, and firmware specifications of the product',
            'Managing people settings',
            'Setting up a server',
            'Interior design'
        ],
        correct: 0,
        explanation: 'Ensures that the product retains its integrity and consistency throughout its lifecycle.'
    },
    {
        id: 157,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Work Performance Data"?',
        options: [
            'Raw observations and measurements identified during activities (e.g., % complete, start date)',
            'The final report',
            'Aggregated status',
            'Calculated KPIs'
        ],
        correct: 0,
        explanation: 'Data -> Information -> Reports. Data is the raw input.'
    },
    {
        id: 158,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Work Performance Information"?',
        options: [
            'Performance data collected from various controlling processes, analyzed in context and integrated',
            'Raw numbers',
            'A dashboard',
            'A guess'
        ],
        correct: 0,
        explanation: 'Data becomes Information when you compare it to the plan (Variance Analysis).'
    },
    {
        id: 159,
        category: 'Integration',
        difficulty: 'Easy',
        question: 'What is the "Project Management Information System" (PMIS)?',
        options: [
            'An information system consisting of the tools and techniques used to gather, integrate, and disseminate the outputs of project management processes',
            'The PM\'s brain',
            'A filing cabinet',
            'A secret book'
        ],
        correct: 0,
        explanation: 'Includes software (MS Project, Jira), configuration management systems, etc.'
    },
    {
        id: 160,
        category: 'Integration',
        difficulty: 'Hard',
        question: 'What is "Assumption Log"?',
        options: [
            'A document used to record all assumptions and constraints throughout the project',
            'A diary',
            'A log of risks',
            'A log of issues'
        ],
        correct: 0,
        explanation: 'Assumptions that prove false become Risks/Issues.'
    },

    // Procurement
    {
        id: 161,
        category: 'Procurement',
        difficulty: 'Hard',
        question: 'What is "Point of Total Assumption" (PTA)?',
        options: [
            'In FPIF contracts, the cost point where the seller assumes all cost overruns (Target Cost + ((Ceiling - Target Price)/Buyer Share))',
            'The point of failure',
            'The max budget',
            'The starting point'
        ],
        correct: 0,
        explanation: 'Above this point, the seller pays $1 for every $1 of cost overrun. Incentive goes to zero.'
    },
    {
        id: 162,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What is "Alternative Analysis" in Procurement?',
        options: [
            'Evaluating different ways to meet requirements (e.g., Buy vs Build)',
            'Looking for new vendors',
            'Changing the project',
            'Analyzing competitors'
        ],
        correct: 0,
        explanation: 'Part of planning strategy.'
    },

    // Communication
    {
        id: 163,
        category: 'Communication',
        difficulty: 'Medium',
        question: 'What is "Paralingual" communication?',
        options: [
            'Pitch and tone of voice',
            'Body language',
            'Written words',
            'Spoken words'
        ],
        correct: 0,
        explanation: 'How you say something is often more important than what you say.'
    },
    {
        id: 164,
        category: 'Communication',
        difficulty: 'Medium',
        question: 'What is the "Communications Management Plan"?',
        options: [
            'Documentation describing how, when, and by whom information will be administered and disseminated',
            'A phone directory',
            'A chat history',
            'A meeting agenda'
        ],
        correct: 0,
        explanation: 'Prevents "noise" and ensures the right people get the right info.'
    },

    // General PMBOK
    {
        id: 165,
        category: 'Framework',
        difficulty: 'Easy',
        question: 'What is a "Phase Gate"?',
        options: [
            'A review at the end of a phase in which a decision is made to continue to the next phase, to continue with modification, or to end',
            'A door',
            'A sprint review',
            'A milestone'
        ],
        correct: 0,
        explanation: 'Also known as a Kill Point.'
    },
    {
        id: 166,
        category: 'Framework',
        difficulty: 'Medium',
        question: 'What is "Organizational Process Assets" (OPA)?',
        options: [
            'Plans, processes, policies, procedures, and knowledge bases specific to and used by the performing organization',
            'Assets like buildings',
            'Market conditions',
            'Government regulations'
        ],
        correct: 0,
        explanation: 'Internal assets that help the project (Templates, Lessons Learned, History).'
    },
    {
        id: 167,
        category: 'Framework',
        difficulty: 'Medium',
        question: 'What is "Enterprise Environmental Factors" (EEF)?',
        options: [
            'Conditions, not under the immediate control of the team, that influence, constrain, or direct the project (e.g., market, culture, laws)',
            'Files on the server',
            'Company templates',
            'Historical data'
        ],
        correct: 0,
        explanation: 'External context you must work within.'
    },
    {
        id: 168,
        category: 'Framework',
        difficulty: 'Hard',
        question: 'What is a "Matrix Organization"?',
        options: [
            'A structure where the team reports to both a Functional Manager and a Project Manager',
            'A simulation',
            'Everyone is a boss',
            'No hierarchy'
        ],
        correct: 0,
        explanation: 'Can be Weak, Balanced, or Strong. Creates dual reporting lines (Two Bosses).'
    },
    {
        id: 169,
        category: 'Framework',
        difficulty: 'Hard',
        question: 'What is the "Project Governance"?',
        options: [
            'The framework, functions, and processes that guide project management activities',
            'Government laws',
            'Software rules',
            'The PMO'
        ],
        correct: 0,
        explanation: 'Provides oversight and control.'
    },
    {
        id: 170,
        category: 'Ethics',
        difficulty: 'Medium',
        question: 'A vendor offers you a gift. What guides your decision?',
        options: [
            'Company policy and PMI Code of Ethics (avoid conflict of interest)',
            'The value of the gift',
            'If anyone is watching',
            'If you like the vendor'
        ],
        correct: 0,
        explanation: 'Fairness and Honesty are key. Usually, decline gifts that could be perceived as influence.'
    },
    {
        id: 171,
        category: 'Closing',
        difficulty: 'Medium',
        question: 'What is "Knowledge Transfer"?',
        options: [
            'Passing project knowledge to the operations/support team or future projects',
            'Uploading files',
            'Teaching a class',
            'Sending an email'
        ],
        correct: 0,
        explanation: 'Critical for transition to operations.'
    },
    {
        id: 172,
        category: 'Closing',
        difficulty: 'Easy',
        question: 'When is a project considered successfully closed?',
        options: [
            'When all records are archived, final report accepted, resources released, and lessons learned documented',
            'When the product is delivered',
            'When the budget is gone',
            'When the PM says so'
        ],
        correct: 0,
        explanation: 'Delivery is not enough. Administrative closure is required.'
    },

    // Wave 4: Procurement - Advanced
    {
        id: 173,
        category: 'Procurement',
        difficulty: 'Hard',
        question: 'What is a "source selection criteria"?',
        options: [
            'A set of attributes desired by the buyer which a seller is required to meet or exceed to be selected',
            'A document listing the preferred search engines for finding qualified vendors',
            'A pre-approved list of sellers that have been vetted by the procurement department',
            'The final contract terms agreed upon by the buyer and the selected seller'
        ],
        correct: 0,
        explanation: 'Crucial for objective vendor selection (scoring models).'
    },
    {
        id: 174,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What is the "Records Management System" in Procurement?',
        options: [
            'A specific set of processes, related control functions, and automation tools that are consolidated and combined to preserve contract documentation',
            'A physical filing cabinet used to store all original signed contracts',
            'The Project Management Information System (PMIS) module used specifically for scheduling',
            'A standardized email folder structure for finding correspondence'
        ],
        correct: 0,
        explanation: 'Mandatory for handling claims and audits.'
    },
    {
        id: 175,
        category: 'Procurement',
        difficulty: 'Hard',
        question: 'What is "Claims Administration"?',
        options: [
            'The process of processing, adjudicating, and communicating contract claims (contested changes)',
            'The process of filing for insurance coverage in case of project failure',
            'A negotiation technique used to request additional budget from the sponsor',
            'A formal legal proceeding initiated by the seller against the buyer'
        ],
        correct: 0,
        explanation: 'If parties cannot agree, it becomes a distinct "Claim". ADR (Alternative Dispute Resolution) is preferred over court.'
    },
    {
        id: 176,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What is a "Bidder Conference"?',
        options: [
            'A meeting with prospective sellers prior to the preparation of a bid or proposal to ensure all have a clear and common understanding',
            'A celebration event held for the winning vendor after contract signature',
            'A private meeting between the buyer and the preferred seller to negotiate terms',
            'A negotiation session where price is finalized'
        ],
        correct: 0,
        explanation: 'Ensures fairness and transparency. No secret collateral comms allowed.'
    },

    // Wave 4: Quality - Advanced
    {
        id: 177,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is a "Scatter Diagram"?',
        options: [
            'A graph that shows the relationship between two variables (Correlation)',
            'A geographic map showing the location of project resources',
            'A chart showing the distribution of probability for risk analysis',
            'A process flow diagram used to identify bottlenecks'
        ],
        correct: 0,
        explanation: 'If points cluster along a diagonal line, the variables are correlated (Positive or Negative).'
    },
    {
        id: 178,
        category: 'Quality',
        difficulty: 'Hard',
        question: 'What is "Statistical Sampling"?',
        options: [
            'Choosing part of a population of interest for inspection',
            'Inspecting 100% of the product to ensure zero defects',
            'Guessing the quality based on past performance',
            'Measuring the average of all data points in a control chart'
        ],
        correct: 0,
        explanation: 'Used when testing is destructive or the population is too large to test 100%.'
    },
    {
        id: 179,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'Difference between "Quality Audit" and "Inspection"?',
        options: [
            'Audit checks the process (are we following the rules?); Inspection checks the product (is it broken?)',
            'Audit and Inspection are synonyms and used interchangeably',
            'Audit is performed by the finance department; Inspection is performed by the safety officer',
            'Inspection checks the process; Audit checks the product'
        ],
        correct: 0,
        explanation: 'Audits are usually performed by an external team.'
    },
    {
        id: 180,
        category: 'Quality',
        difficulty: 'Easy',
        question: 'What is "Benchmarking"?',
        options: [
            'Comparing actual or planned project practices to those of comparable projects to identify best practices',
            'Setting a baseline for the project schedule',
            'Marking a physical line on the product to indicate quality limits',
            'Setting a goal for the team to reach by the end of the sprint'
        ],
        correct: 0,
        explanation: 'It generates ideas for improvement and provides a basis for measuring performance.'
    },

    // Wave 4: Resources - Advanced
    {
        id: 181,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is a "Resource Calendar"?',
        options: [
            'A calendar that identifies the working days and shifts on which each specific resource is available',
            'A standard calendar showing national holidays only',
            'A team meeting invite sent to all stakeholders',
            'A document tracking the vacation time of the project manager'
        ],
        correct: 0,
        explanation: 'Crucial for accurate scheduling (people take vacations!).'
    },
    {
        id: 182,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'What is "McClelland’s Theory of Needs"?',
        options: [
            'People are motivated by Achievement, Power, or Affiliation',
            'People are motivated by physiological, safety, and social needs',
            'People are motivated by rewards and punishments (Carrot and Stick)',
            'People are either Theory X (lazy) or Theory Y (motivated)'
        ],
        correct: 0,
        explanation: 'Good managers tailor their style to the dominant need of the employee.'
    },
    {
        id: 183,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is a "RAM" (Responsibility Assignment Matrix)?',
        options: [
            'A grid that shows the project resources assigned to each work package',
            'A type of computer memory used in project planning software',
            'A document listing the names of all project team members',
            'A detailed schedule of when resources are needed'
        ],
        correct: 0,
        explanation: 'The RACI chart is a type of RAM.'
    },
    {
        id: 184,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is "Colocation"?',
        options: [
            'Placing many or all of the most active project team members in the same physical location aka "War Room"',
            'Moving all servers to a cloud provider',
            'Allowing team members to work remotely from home',
            'Outsourcing the project to a vendor in a different country'
        ],
        correct: 0,
        explanation: 'Improves communication and sense of team.'
    },
    {
        id: 185,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'Best conflict resolution technique for long-term relationships?',
        options: [
            'Collaborate / Problem Solve',
            'Force / Direct',
            'Smooth / Accommodate',
            'Compromise / Reconcile'
        ],
        correct: 0,
        explanation: 'Collaboration confronts the problem, not the person, and finds a win-win.'
    },
    {
        id: 186,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is "Compromise" in conflict resolution?',
        options: [
            'Searching for a solution that brings some degree of satisfaction to all parties (Lose-Lose)',
            'Searching for a solution where one party wins and the other loses (Win-Lose)',
            'Retreating from an actual or potential conflict situation (Withdraw)',
            'Pushing one\'s viewpoint at the expense of others (Force)'
        ],
        correct: 0,
        explanation: 'Both sides give up something. It is distinct from Collaboration (Win-Win).'
    },

    // Wave 4: Integration - Advanced
    {
        id: 187,
        category: 'Integration',
        difficulty: 'Hard',
        question: 'What is "Corrective Action"?',
        options: [
            'An intentional activity that realigns the performance of the project work with the project management plan',
            'An intentional activity to fix a non-conforming product or component',
            'An intentional activity that ensures the future performance of the project work is aligned with the plan',
            'An immediate action taken to respond to a realized risk'
        ],
        correct: 0,
        explanation: 'Corrective puts you back on track. Preventive keeps you on track. Defect Repair fixes a non-conforming product.'
    },
    {
        id: 188,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Preventive Action"?',
        options: [
            'An intentional activity that ensures the future performance of the project work is aligned with the project management plan',
            'An intentional activity that realigns the performance of the project work with the project management plan',
            'An activity to repair a defect found during quality inspection',
            'A response strategy for a negative risk that has occurred'
        ],
        correct: 0,
        explanation: 'Proactive vs Reactive.'
    },
    {
        id: 189,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Manage Project Knowledge"?',
        options: [
            'Using existing knowledge and creating new knowledge to achieve the project\'s objectives and contribute to organizational learning',
            'The process of storing all project documents in a central repository',
            'Conducting a Google search to find answers to technical problems',
            'Writing a book about the project after it is closed'
        ],
        correct: 0,
        explanation: 'Explicit knowledge (files) vs Tacit knowledge (experience/beliefs).'
    },

    // Wave 4: Tools
    {
        id: 190,
        category: 'Quality',
        difficulty: 'Hard',
        question: 'What is a "Histogram"?',
        options: [
            'A bar chart that shows the graphical representation of numerical data',
            'A line graph showing trends over time',
            'A diagram showing the hierarchy of the project team',
            'A chart showing the relationship between two variables'
        ],
        correct: 0,
        explanation: 'The Pareto Chart is a specific type of histogram ordered by frequency.'
    },
    {
        id: 191,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is a "Mind Map"?',
        options: [
            'A diagram used to visually organize information, starting from a central idea',
            'A medical scan of the brain',
            'A detailed roadmap of the project deliverables',
            'A psychological test for team members'
        ],
        correct: 0,
        explanation: 'Great for gathering requirements or brainstorming quality problems.'
    },
    {
        id: 192,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What is "Sole Source" vs "Single Source"?',
        options: [
            'Sole Source: Only one provider exists. Single Source: You choose one provider among many (preferred).',
            'Sole Source: You choose one provider. Single Source: Only one provider exists.',
            'Sole Source is preferred for cost savings. Single Source is illegal.',
            'They are synonyms and can be used interchangeably.'
        ],
        correct: 0,
        explanation: 'Single source is risky but might be done for relationship/quality reasons.'
    },
    {
        id: 193,
        category: 'Resources',
        difficulty: 'Hard',
        question: 'What is "Halo Effect"?',
        options: [
            'Cognitive bias where a specific trait (e.g., great developer) influences the overall impression (e.g., must be a great manager)',
            'A visual effect used in project presentations',
            'A religious concept applied to ethical management',
            'The effect of good lighting on team productivity'
        ],
        correct: 0,
        explanation: 'Assuming a good coder will be a good PM is a classic mistake due to the Halo Effect.'
    },
    {
        id: 194,
        category: 'Stakeholders',
        difficulty: 'Medium',
        question: 'What is "Leading" in the Stakeholder Engagement Matrix?',
        options: [
            'Aware of project and potential impacts and actively engaged in ensuring the project is a success',
            'The project manager or sponsor',
            'The stakeholder with the most power',
            'A stakeholder who is resistant to the project'
        ],
        correct: 0,
        explanation: 'Levels: Unaware, Resistant, Neutral, Supportive, Leading.'
    },
    {
        id: 195,
        category: 'Procurement',
        difficulty: 'Hard',
        question: 'What is a "Letter of Intent"?',
        options: [
            'A letter expressing intention to hire a vendor, often to allow work to start before the full contract is signed',
            'A legally binding final contract',
            'A rejection letter sent to losing bidders',
            'A document documenting the lessons learned'
        ],
        correct: 0,
        explanation: 'It is NOT a contract, but carries some legal weight.'
    },
    {
        id: 196,
        category: 'Resources',
        difficulty: 'Medium',
        question: 'What is "Multi-criteria Decision Analysis"?',
        options: [
            'A technique utilizing a decision matrix to provide a systematic analytical approach for establishing criteria (e.g., risk, uncertainty, valuation)',
            'A voting method where the majority wins',
            'Guessing based on intuition',
            'Flipping a coin to decide between two options'
        ],
        correct: 0,
        explanation: 'Used for hiring staff or selecting vendors.'
    },
    {
        id: 197,
        category: 'Quality',
        difficulty: 'Medium',
        question: 'What is "Root Cause Analysis" (RCA)?',
        options: [
            'An analytical technique used to determine the basic underlying reason that causes a variance or a defect or a risk',
            'A method for excavating the project site',
            'A technique for pruning the project schedule',
            'Identifying the first task in the project plan'
        ],
        correct: 0,
        explanation: 'Common tools: Fishbone (Ishikawa) diagram, 5 Whys.'
    },
    {
        id: 198,
        category: 'Resources',
        difficulty: 'Easy',
        question: 'What is "Team Charter"?',
        options: [
            'A document that records the team values, agreements, and operating guidelines',
            'A boat rented for team building usage',
            'A formal contract signed by the team members',
            'The project charter signed by the sponsor'
        ],
        correct: 0,
        explanation: 'Establishes ground rules for acceptable behavior.'
    },
    {
        id: 199,
        category: 'Framework',
        difficulty: 'Medium',
        question: 'What is a "Program"?',
        options: [
            'A group of related projects managed in a coordinated way to obtain benefits not available from managing them individually',
            'A very large project with a high budget',
            'A software application used for project management',
            'A television show about project management'
        ],
        correct: 0,
        explanation: 'Project = Output. Program = Outcome/Benefit.'
    },

    // Wave 5: Communications - Advanced
    {
        id: 200,
        category: 'Communication',
        difficulty: 'Medium',
        question: 'What is the "Sender-Receiver Model"?',
        options: [
            'Encode -> Transmit -> Decode -> Acknowledge -> Feedback',
            'Talk -> Listen',
            'Email -> Read',
            'Manager -> Employee'
        ],
        correct: 0,
        explanation: 'Feedback is the only way to ensure the message was understood correctly.'
    },
    {
        id: 201,
        category: 'Communication',
        difficulty: 'Hard',
        question: 'What percentage of communication is non-verbal (according to Mehrabian)?',
        options: [
            '~55% (Body Language)',
            '10%',
            '90%',
            '0%'
        ],
        correct: 0,
        explanation: '7% Words, 38% Tonality, 55% Body Language. (Roughly).'
    },
    {
        id: 202,
        category: 'Communication',
        difficulty: 'Medium',
        question: 'What is "Interactive Communication"?',
        options: [
            'Between two or more parties performing a multidirectional exchange of information (Meetings, Calls)',
            'Push',
            'Pull',
            'One way'
        ],
        correct: 0,
        explanation: 'Most effective for ensuring common understanding.'
    },
    {
        id: 203,
        category: 'Communication',
        difficulty: 'Hard',
        question: 'What is the "Communications Channels Formula" for 10 people?',
        options: [
            '45',
            '10',
            '90',
            '50'
        ],
        correct: 0,
        explanation: '10 * 9 / 2 = 45. As team size grows linearly, complexity grows exponentially.'
    },
    {
        id: 204,
        category: 'Communication',
        difficulty: 'Medium',
        question: 'What is "Pull Communication"?',
        options: [
            'Used for large volumes of information or large audiences who access content at their own discretion (e.g., Intranet, eLearning)',
            'Email',
            'Meetings',
            'Fax'
        ],
        correct: 0,
        explanation: 'The recipient is responsible for retrieving the info.'
    },

    // Wave 5: Ethics & Professional Conduct
    {
        id: 205,
        category: 'Ethics',
        difficulty: 'Hard',
        question: 'You suspect a team member of violating the code of conduct but have no proof. What do you do?',
        options: [
            'Investigate deeper or report to the appropriate body for investigation before accusing',
            'Fire them',
            'Ignore it',
            'Gossip to the team'
        ],
        correct: 0,
        explanation: 'Accusations must be based on fact. Process must be followed.'
    },
    {
        id: 206,
        category: 'Ethics',
        difficulty: 'Medium',
        question: 'A project is cancelled. The customer asks for the code written so far, even though it is not finished. The contract says they own all work product. What do you do?',
        options: [
            'Release the work product as per contract',
            'Withhold it until paid',
            'Delete it',
            'Encrypt it'
        ],
        correct: 0,
        explanation: 'Honour the contract and property rights.'
    },
    {
        id: 207,
        category: 'Ethics',
        difficulty: 'Hard',
        question: 'You realize you do not have the qualifications to manage a complex nuclear project you were assigned. What should you do?',
        options: [
            'Inform the sponsor/management about your lack of expertise and either decline or request support/training',
            'Fake it till you make it',
            'Accept and hope for the best',
            'Hire a consultant secretly'
        ],
        correct: 0,
        explanation: 'PMI Code: Responsibility. Accept only assignments you are qualified for.'
    },
    {
        id: 208,
        category: 'Ethics',
        difficulty: 'Medium',
        question: 'Cultural Awareness / Diversity:',
        options: [
            'PMs must be aware of cultural norms (holidays, communication styles, work ethics) to manage global teams effectively',
            'Everyone should act the same',
            'Ignore culture',
            'Only follow HQ culture'
        ],
        correct: 0,
        explanation: 'Respect implies cultural sensitivity.'
    },

    // Wave 5: Closing & Transitions
    {
        id: 209,
        category: 'Closing',
        difficulty: 'Medium',
        question: 'What is "Transition to Operations"?',
        options: [
            'Handing over the product, documentation, and training to the team that will maintain it',
            'Abandoning the project',
            'Firing the dev team',
            'Starting phase 2'
        ],
        correct: 0,
        explanation: 'Often includes a warranty period.'
    },
    {
        id: 210,
        category: 'Closing',
        difficulty: 'Medium',
        question: 'What happens to the "Lessons Learned Register" at closing?',
        options: [
            'It is transferred to the Organizational Process Assets (OPA) for future projects',
            'It is deleted',
            'It is printed and framed',
            'It is emailed to the client'
        ],
        correct: 0,
        explanation: 'The project knowledge becomes organizational knowledge.'
    },
    {
        id: 211,
        category: 'Closing',
        difficulty: 'Hard',
        question: 'A stakeholder raises a new minor requirement during the Closing Phase. What do you do?',
        options: [
            'Encourage them to open a new project or maintenance request. The scope is now closed.',
            'Do it quickly',
            'Reopen the project',
            'Ignore them'
        ],
        correct: 0,
        explanation: 'Closing is for wrapping up, not new development.'
    },

    // Wave 5: Business Environment
    {
        id: 212,
        category: 'Business',
        difficulty: 'Hard',
        question: 'What is "Benefits Management Plan"?',
        options: [
            'Describes how and when the benefits of the project get delivered and how they should be measured',
            'A profit plan',
            'A bonus plan',
            'A schedule'
        ],
        correct: 0,
        explanation: 'Project success is measured by benefits realization, not just "on time/on budget".'
    },
    {
        id: 213,
        category: 'Business',
        difficulty: 'Medium',
        question: 'What is "compliance"?',
        options: [
            'Meeting legal, regulatory, and organizational requirements',
            'Doing what the boss says',
            'Being nice',
            'Ignoring rules'
        ],
        correct: 0,
        explanation: 'Non-compliance is a major risk.'
    },
    {
        id: 214,
        category: 'Agile',
        difficulty: 'Hard',
        question: 'What is "Minimum Viable Product" (MVP)?',
        options: [
            'A version of a product with just enough features to be usable by early customers who can then provide feedback for future product development',
            'A beta',
            'A prototype',
            'Final product'
        ],
        correct: 0,
        explanation: 'Maximizes learning with least effort.'
    },

    // Wave 5: Final Mix
    {
        id: 215,
        category: 'Integration',
        difficulty: 'Medium',
        question: 'What is "Tailoring"?',
        options: [
            'Determining the appropriate combination of processes, inputs, tools, techniques, outputs, and life cycle phases to manage a project',
            'Sewing clothes',
            'Skipping steps',
            'Adding bureaucracy'
        ],
        correct: 0,
        explanation: 'One size does not fit all. PMBOK is a guide, not a rulebook.'
    },
    {
        id: 216,
        category: 'Stakeholders',
        difficulty: 'Easy',
        question: 'Communication vs Engagement:',
        options: [
            'Communication is the tool; Engagement is the result/goal',
            'They are the same',
            'Engagement is talking',
            'Communication is caring'
        ],
        correct: 0,
        explanation: 'You can communicate without engaging people.'
    },
    {
        id: 217,
        category: 'Schedule',
        difficulty: 'Hard',
        question: 'Resource Leveling vs Smoothing (Again):',
        options: [
            'Leveling can change the critical path; Smoothing does not',
            'Smoothing changes the end date',
            'Leveling uses float only',
            'They represent the same mathematical principal'
        ],
        correct: 0,
        explanation: 'Leveling = Hard constraint on resources. Smoothing = Hard constraint on Time.'
    },
    {
        id: 218,
        category: 'Procurement',
        difficulty: 'Medium',
        question: 'What is "Fixed Price Incentive Fee" (FPIF)?',
        options: [
            'A fixed price contract where the seller can earn an additional fee if they meet defined performance metrics (cost, time, quality)',
            'A bonus for everyone',
            'A variable price',
            'A risky contract'
        ],
        correct: 0,
        explanation: 'Aligns incentives between buyer and seller.'
    },
    {
        id: 219,
        category: 'Communication',
        difficulty: 'Hard',
        question: 'What is "Communication Noise"?',
        options: [
            'Anything that interferes with the transmission and understanding of the message (distance, language, culture, technical issues)',
            'Loud sounds',
            'Too many emails',
            'Bad internet'
        ],
        correct: 0,
        explanation: 'PM must actively reduce noise.'
    },
    {
        id: 220,
        category: 'Risk',
        difficulty: 'Medium',
        question: 'What is a "Contingency Plan"?',
        options: [
            'A plan that is executed only when specific trigger conditions occur',
            'A backup plan',
            'A risk response',
            'All of the above'
        ],
        correct: 0,
        explanation: 'It is "Active Acceptance" of a risk.'
    },
    {
        id: 221,
        category: 'Framework',
        difficulty: 'Easy',
        question: 'Agile Manifesto: Individuals and interactions over ...?',
        options: [
            'Processes and tools',
            'Comprehensive documentation',
            'Contract negotiation',
            'Following a plan'
        ],
        correct: 0,
        explanation: 'Valuing people more than the process.'
    },
    {
        id: 222,
        category: 'Framework',
        difficulty: 'Easy',
        question: 'Agile Manifesto: Working software over ...?',
        options: [
            'Comprehensive documentation',
            'Processes and tools',
            'Contract negotiation',
            'Following a plan'
        ],
        correct: 0,
        explanation: 'Documentation is useful, but working software is the primary measure of progress.'
    },
    {
        id: 223,
        category: 'Framework',
        difficulty: 'Easy',
        question: 'Agile Manifesto: Customer collaboration over ...?',
        options: [
            'Contract negotiation',
            'Processes and tools',
            'Comprehensive documentation',
            'Following a plan'
        ],
        correct: 0,
        explanation: 'Contracts are important, but collaboration solves problems.'
    },
    {
        id: 224,
        category: 'Framework',
        difficulty: 'Easy',
        question: 'Agile Manifesto: Responding to change over ...?',
        options: [
            'Following a plan',
            'Processes and tools',
            'Comprehensive documentation',
            'Contract negotiation'
        ],
        correct: 0,
        explanation: 'Plans are useless; planning is indispensable. Adaptability is key.'
    }
];
